import { ref } from 'vue';

// Create a singleton instance that persists across imports
const banner = ref('');
const bannerStyle = ref('success');

export function useFlash() {
    const flash = (message, style = 'success') => {
        banner.value = message;
        bannerStyle.value = style;
    };

    const clear = () => {
        banner.value = '';
    };

    return {
        banner,
        bannerStyle,
        flash,
        clear
    };
}
